import useUser from '@/hooks/useUser';
import { useCallback } from 'react';

export default function useSelectWatchlist() {
  const { mutate } = useUser();

  const selectWatchlist = useCallback(
    (id: string | null) => {
      mutate({
        settings: {
          default_watchlist_id: id,
        },
      });
    },
    [mutate]
  );

  return selectWatchlist;
}
